@if (showEventTimerInfoSection) {
    @if (showFavouriteIcon) {
        <span class="favourite selected"><vn-icon name="theme-favorite-i" size="10" /></span>
    }
    @if (event.scoreboard.started) {
        <i class="live-icon" [class.live-red-dot]="isLeagueChildPageDesign && !isOutrightMarket">{{ liveIconText }}</i>
    }
    @if (raceInfo) {
        <ms-race-info [event]="event" />
    }
    @if (event.liveAlert) {
        <ms-alert class="alert-icon alert-grid-view" [disable]="true" [eventModel]="event" />
    }
    @if (event.stream && !mediaEnabled && showVideoIcon) {
        <span class="video-icon" [class.video-icon-live]="event.live"><vn-icon name="sports-video-badge-b" width="15" height="10" /></span>
    }
    @if (event.league.combiLeague) {
        <span class="sport-icon"><vn-icon name="sports-{{ event.sport.id }}" size="11" /></span>
    }
    <div class="event-info-container">
        <ms-event-timer
            class="grid-event-timer"
            [class.price-boost-wrapper]="getPriceBoost()"
            [live]="event.live"
            [start]="event.startDate"
            [scoreboard]="event.scoreboard" />
        @if (broadcaster$ | async; as broadcaster) {
            <div class="broadcast-info-ellipsis"><span class="dot">•</span>{{ broadcaster }}</div>
        }
    </div>
    @if (liveEventInfo) {
        <span class="grid-live-event-info">{{ liveEventInfo }}</span>
    }
}
@if (showFixedFooterSection) {
    <ng-content />
    @if (showBetBuilderIcon) {
        <span class="bet-builder-icon" (click)="builderClick($event)">
            @if (showIcon) {
                <i class="sports-build-a-bet"></i>
            }

            @if (shouldShowLiveSgpTooltip) {
                <div
                    [popper]="tooltipPopper"
                    [popperShowOnStart]="true"
                    [popperAppendTo]="'ms-six-pack-event'"
                    [popperPlacement]="NgxPopperjsPlacements.TOP"
                    [popperBoundaries]="'ms-event-group'"
                    [popperApplyClass]="'home-lobby-event-group-tooltip'"
                    [popperApplyArrowClass]="'popper-arrow'"
                    [popperHideOnClickOutside]="true"
                    [popperHideOnScroll]="false"
                    [popperPreventOverflow]="true"></div>
            }

            <span class="bet-builder-text">{{ sitecore.eventGrid.BetBuilderBadgeText }}</span>
        </span>
    }
    <ng-template #header>
        <ms-betbuilder-overlay-header
            [eventName]="event.name"
            [sportId]="event.sport.id"
            [leagueId]="event.league.id"
            [eventId]="event.id"
            [eventStartDate]="event.startDate"
            [eventParticipants]="event.participants"
            [eventViewType]="event.viewType" />
    </ng-template>
    @if (priceBoostCount) {
        <ms-priceboost-count-signpost [count]="priceBoostCount.toString()" />
    }
    <popper-content #tooltipPopper>
        <ms-onboarding-tooltip [showHelp]="true" [message]="tooltipText" (closeClicked)="onCloseAngstromLiveSgpTooltip()" />
    </popper-content>
}
